module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ({

/***/ 17:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global) {const $wj_tools = {
  $ENV: function () {
    const payload = {
      userAgent: "",
      /*
       * 所有key名对应的value
       * value：[ [第一个数组是需要存在的匹配关键字],[第二个数组是需要不匹配上的关键字] ]
       */
      isWeixin: [["MicroMessenger"], ["wxwork"]],
      isWxwork: [["MicroMessenger", "wxwork"]],
      isLark: [["Lark"]],
      // 飞书
      isDingTalk: [["DingTalk"]] // 钉钉
    };

    const state = {};
    // 存储信息数据
    return {
      // 设置Ua的来源信息
      setUserAgent(ua) {
        Reflect.set(payload, "userAgent", ua);
      },
      // 扩展列表私有属性 payload 对象
      $extend(name, value) {
        if (typeof name === "object") {
          Object.assign(payload, name);
        } else {
          payload[name] = value;
        }
      },
      // 查看对应的key 或者全部key
      viewList(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (key && payload.hasOwnProperty(key)) return Reflect.get(payload, key);
        return payload;
      },
      /**
       * @description： 返回判断环境
       * @param {String in keyof payload} name
       * @return {Boolean}
       *
       */
      get(name) {
        var _global, _global$window, _global$window$naviga;
        // 缓存已经读取过的数据
        if (Reflect.has(state, name)) return Reflect.get(state, name);
        if (name === "userAgent") return Reflect.get(payload, name);
        const [inc = [], exc = []] = Reflect.get(payload, name) || [];
        const au = payload.userAgent || ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || "";
        const status = inc.every(s => au.includes(s)) && exc.every(s => !au.includes(s));
        Reflect.set(state, name, status);
        return status;
      },
      // 移除数据中心
      remove(key) {
        Reflect.deleteProperty(payload, key);
      },
      // thunk执行者函数
      defineState() {
        let middlewareThunk = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => ({});
        let keyName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "defineState";
        // eslint-disable-next-line no-return-assign
        return this[keyName] = function () {
          return middlewareThunk(...arguments);
        };
      }
    };
  }(),
  // 后续扩展其定义
  defineInit() {},
  /**
   *
   * @param {Object} data , 就是接口对象
   * @description : 获取套餐接口数据，格式化有效数据
   * @returns Object <{
   *               version：: 当前版本
   *               expireTime：有效时间
   *               nextVersion：下一个版本
   *           }>
   * }
   */
  formatUserPackageInfo(data) {
    // 套餐类型
    const versiobnMap = ["free", "advance_version", "enterprise_version", "enterprise_ultimate_version"];
    let [version, expireTime, isTry] = ["free", "", false];
    if (data.package_status) {
      /**
       * advance_version 高级版本
       * enterprise_version 企业版标准版
       * enterprise_ultimate_version'; // 企业旗舰版
       */
      isTry = !!data.package_status.is_trial;
      version = data.package_status.version;
      expireTime = data.package_status.expire_time || "";
    }
    // 免费版本能升级,其他版本只能续费
    const index = versiobnMap.indexOf(version); // 当前版本索引
    const nextVersion = versiobnMap[index === versiobnMap.length - 1 ? versiobnMap.length - 1 : index + 1]; // 下一本版本名称
    return {
      version,
      // 当前版本
      expireTime,
      // 有效时间
      nextVersion,
      // 下一个升级版本  名称
      isTry,
      // 是不是试用版
      isFree: version == "free",
      // 是不是免费版本
      isAdv: version === "advance_version" && !isTry,
      // 是不是高级版
      isEnt: version === "enterprise_version" && !isTry,
      // 是不是企业版
      isUlt: version === "enterprise_ultimate_version" && !isTry,
      // 是不是旗舰版
      freeName: "free",
      advName: "advance_version",
      // 高级版名称
      entName: "enterprise_version",
      ultName: "enterprise_ultimate_version"
    };
  },
  /**
   * 校验格式函数
   */
  checkRules: (() => ({
    // 邮箱校验
    isEmail(value, customExp) {
      const exp = customExp || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return exp === null || exp === void 0 ? void 0 : exp.test(value);
    },
    // 国内座机号
    isLandlinePhone(value, customExp) {
      const exp = customExp || /0\d{2,3}-?\d{7,8}/;
      return exp.test(value);
    },
    // 国内手机号
    isMobile(value) {
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 9;
      let customExp = arguments.length > 2 ? arguments[2] : undefined;
      const exp = customExp || new RegExp(`^1[3456789]\\d{${size}}$`);
      return exp.test(value);
    },
    // 纯数字 0 - 9
    isNumber(value) {
      return /^[0-9]+$/.test(value);
    }
  }))(),
  questionTypeList(expendsData) {
    const types = {
      "2": {
        template: "q-select",
        name: "单选",
        formName: "单选",
        satisName: "单选",
        title: "请选择一个选项",
        option: "选项",
        trackName: "single_select"
      },
      "3": {
        template: "q-select",
        name: "多选",
        formName: "多选",
        satisName: "多选",
        title: "请选择以下选项 (多选)",
        subtitle: "单选题",
        option: "选项",
        trackName: "multiple_select"
      },
      "4": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "请选择以下选项",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "5": {
        template: "q-matrix-default",
        name: "矩阵选择",
        title: "矩阵单选题",
        option: "选项",
        suboption: "矩阵行",
        trackName: "matrix_select"
      },
      "6": {
        template: "q-blank",
        name: "填空",
        formName: "填空",
        title: "请填写本项内容",
        trackName: "blank"
      },
      "7": {
        template: "q-matrix-default",
        name: "矩阵打分",
        title: "请给以下各项打分",
        satisTitle: "请问你对以下描述的感觉是",
        option: "打分",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "8": {
        template: "q-blank",
        name: "级联题",
        title: "出生日期",
        trackName: "date"
      },
      "9": {
        template: "q-classification",
        name: "分类",
        title: "请按照分类规则，将左侧选项拖入右侧分组中",
        option: "选项",
        suboption: "类别",
        trackName: "classification"
      },
      "50": {
        template: "q-score",
        name: "打分",
        formName: "打分",
        title: "请给本项打分",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "选项",
        trackName: "score"
      },
      "60": {
        template: "q-default",
        name: "排序",
        formName: "排序",
        title: "请给以下选项排序",
        option: "选项",
        trackName: "sort"
      },
      "70": {
        template: "q-desc",
        name: "段落说明",
        title: "请阅读本项说明，然后回答问题",
        trackName: "remark"
      },
      "95": {
        template: "q-multi-blank",
        name: "多项填空",
        title: "请填写以下内容",
        option: "填空",
        trackName: "multiple_blank"
      },
      "100": {
        template: "q-matrix-default",
        name: "矩阵填空",
        title: "请填写以下内容",
        option: "填空",
        suboption: "矩阵行",
        trackName: "matrix_blank"
      },
      "105": {
        template: "q-goods",
        name: "商品",
        formName: "商品",
        title: "请挑选您喜欢的商品",
        subtitle: "商品题",
        option: "选项",
        trackName: "goods"
      },
      collection: {
        template: "q-collection",
        name: "收款题",
        formName: "收款",
        createFn: "createCollection",
        trackName: "collection"
      },
      contact_us: {
        template: "q-contact-us",
        name: "联系我们",
        createFn: "createContactUs",
        trackName: "contact_us"
      },
      enterprise_certification_info: {
        template: "q-enterprise-auth",
        createFn: "createEnterpriseAuth",
        name: "企业认证",
        trackName: "enterprise_certification_info"
      },
      user_info: {
        template: "q-user-info",
        name: "个人信息",
        title: "个人信息录入"
      },
      exam_inform: {
        template: "q-exam-inform",
        name: "考前须知",
        title: "考前须知"
      },
      geographical_multiple_blank: {
        template: "q-geographical",
        name: "地理位置",
        title: "所在位置",
        trackName: "geography"
      },
      rich_text: {
        template: "q-rich",
        name: "图文介绍",
        title: "请阅读本项说明，然后回答问题",
        trackName: "rich"
      },
      occupation: {
        template: "q-select",
        name: "职业",
        title: "您目前的职业是？",
        option: "在校学生",
        suboption: "政府/机关干部/公务员",
        trackName: "occupation"
      },
      singlevote: {
        template: "q-default",
        name: "文字投票",
        title: "请给以下选项投票",
        option: "选项",
        trackName: "font_vote"
      },
      education: {
        template: "q-select",
        name: "学历",
        title: "您的最高学历（含目前在读）是？",
        option: "小学及以下",
        suboption: "初中",
        trackName: "education"
      },
      sex: {
        template: "q-select",
        name: "性别",
        title: "性别",
        option: "男",
        suboption: "女",
        trackName: "sex"
      },
      age: {
        template: "q-select",
        name: "年龄",
        satisName: "年龄段",
        title: "您的年龄是？",
        option: "18岁以下",
        suboption: "18~24岁",
        trackName: "age"
      },
      judge: {
        template: "q-select",
        name: "判断题",
        title: "请判断本项叙述是否正确？",
        option: "是",
        suboption: "否",
        trackName: "single_select"
      },
      multiplevote: {
        template: "q-default",
        name: "文字投票题",
        title: "请给以下选项投票（多选）",
        option: "选项",
        trackName: "font_vote_multiple"
      },
      groupvote_single: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票",
        option: "选项",
        trackName: "groupvote_single"
      },
      groupvote_multiple: {
        template: "q-video-vote",
        name: "分组投票",
        title: "请给以下分组投票（多选）",
        option: "选项",
        trackName: "groupvote_multiple"
      },
      videovote_single: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票"
      },
      videovote_multiple: {
        template: "q-video-vote",
        name: "视频投票",
        title: "请给以下视频投票（多选）"
      },
      listening_single: {
        template: "q-select",
        name: "听力题",
        title: "点击上传音频/视频文件",
        option: "选项",
        trackName: "listen"
      },
      dropdown: {
        template: "q-default",
        name: "下拉",
        formName: "下拉",
        title: "请选择一个选项",
        option: "选项",
        trackName: "dropdown"
      },
      short_answer: {
        template: "q-blank",
        name: "简答题",
        title: "请简要阐述你的观点",
        trackName: "short_answer"
      },
      name: {
        template: "q-blank",
        name: "姓名",
        title: "姓名",
        trackName: "name"
      },
      mobile: {
        template: "q-blank",
        name: "手机",
        title: "手机",
        trackName: "mobile"
      },
      email: {
        template: "q-blank",
        name: "邮箱",
        title: "邮箱",
        trackName: "email"
      },
      wechat_id: {
        template: "q-blank",
        name: "微信号",
        title: "微信号",
        trackName: "wechat_id"
      },
      id_card: {
        template: "q-blank",
        name: "身份证号",
        title: "身份证号",
        trackName: "id_card"
      },
      employee_id: {
        template: "q-blank",
        name: "工号",
        title: "工号",
        trackName: "employee_id"
      },
      blank_num: {
        template: "q-blank",
        name: "数字填空",
        title: "数字",
        trackName: "blank_num"
      },
      classes: {
        template: "q-blank",
        name: "班级",
        title: "班级",
        trackName: "classes"
      },
      grades: {
        template: "q-blank",
        name: "年级",
        title: "年级",
        trackName: "grades"
      },
      student_id: {
        template: "q-blank",
        name: "学号",
        title: "学号",
        trackName: "student_id"
      },
      company: {
        template: "q-blank",
        name: "公司",
        title: "公司",
        trackName: "company"
      },
      department: {
        template: "q-blank",
        name: "部门",
        title: "部门",
        trackName: "department"
      },
      university_form: {
        template: "q-blank",
        name: "学校",
        title: "学校",
        trackName: "university_form"
      },
      major_form: {
        template: "q-blank",
        name: "专业",
        title: "专业",
        trackName: "major_form"
      },
      phone: {
        template: "q-phone",
        trackName: "mobile"
      },
      multi_line_blank: {
        template: "q-multiline-blank",
        trackName: "multiple_blank"
      },
      auto_table: {
        template: "q-auto-table",
        name: "自增表格",
        title: "请填写你的团队成员信息",
        option: "标题",
        trackName: "auto_table"
      },
      horz_blank: {
        template: "q-horz-blank",
        name: "横向填空",
        title: "请填写以下信息",
        option: '姓名<span class="ipt-wrap"><input type="text" style="width: 64px"></span>年龄<span class="ipt-wrap"><input type="text" style="width: 32px"></span>岁<br>联系方式<span class="ipt-wrap"><input type="text" style="width: 88px"></span>',
        trackName: "horizontal_blank"
      },
      cloze: {
        template: "q-cloze",
        name: "完形填空",
        title: "完形填空",
        trackName: "cloze"
      },
      banked_cloze: {
        template: "q-banked-cloze",
        name: "选词填空",
        title: "选词填空",
        option: "选项",
        suboption: ["请输入标题", "的", "地", "得"],
        trackName: "banked_cloze"
      },
      date: {
        template: "q-blank",
        name: "日期",
        title: "日期",
        trackName: "date"
      },
      upload_file: {
        template: "q-upload-file",
        name: "文件收集",
        title: "请上传文件",
        trackName: "upload"
      },
      image_upload: {
        template: "q-image-upload",
        name: "图片收集",
        assessName: "图片收集",
        title: "请上传图片",
        trackName: "image_upload"
      },
      time: {
        template: "q-time",
        name: "时间",
        title: "时间",
        trackName: "time"
      },
      signature: {
        template: "q-signature",
        name: "电子签名",
        subtitle: "请在此处签名",
        title: "签名",
        trackName: "signature"
      },
      image_single: {
        template: "q-image",
        name: "图片选择",
        formName: "图片单选",
        title: "请选择以下图片",
        option: "图片",
        trackName: "image_select"
      },
      image_multiple: {
        template: "q-image",
        name: "图片多选",
        title: "请选择以下图片（多选）",
        option: "图片",
        trackName: "image_multiple"
      },
      imagevote_single: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票",
        option: "图片",
        trackName: "image_vote"
      },
      imagevote_multiple: {
        template: "q-video-vote",
        name: "图片投票",
        title: "请给以下图片投票（多选）",
        option: "图片",
        trackName: "image_vote"
      },
      nps_score: {
        template: "q-nps-score",
        name: "NPS",
        formName: "NPS",
        title: "您向朋友或同事推荐我们的可能性有多大？",
        trackName: "nps"
      },
      scale: {
        template: "q-scale",
        name: "量表",
        title: "请您对此项目进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        option: "标题",
        trackName: "scale"
      },
      matrix_scale: {
        template: "q-matrix-scale",
        name: "矩阵量表",
        title: "请您对以下各行内容进行评价",
        satisTitle: "请问你对以下描述的感觉是",
        appraiseTitle: "以下人员在沟通能力方面，能够做到善于沟通，合理协调。",
        option: "标题",
        trackName: "matrix_scale"
      },
      city: {
        template: "q-city",
        trackName: "address"
      },
      address: {
        template: "q-address",
        name: "城市/地址",
        formName: "城市/地址",
        satisName: "城市",
        title: "地址",
        trackName: "address"
      },
      major: {
        template: "q-cascader",
        name: "专业",
        trackName: "major"
      },
      industry: {
        template: "q-cascader",
        name: "行业",
        trackName: "industry"
      },
      cascader: {
        template: "q-cascader",
        name: "多级下拉",
        formName: "多级下拉",
        title: "请选择以下选项",
        trackName: "cascader"
      },
      university: {
        template: "q-cascader",
        name: "院校",
        trackName: "university"
      },
      proportion: {
        template: "q-proportion",
        name: "比重",
        formName: "比重",
        title: "请选择以下各项所占的百分比",
        option: "选项",
        trackName: "proportion"
      },
      evaluation: {
        template: "q-evaluation",
        name: "评价",
        formName: "评价",
        title: "请您对我们的服务进行评价",
        subtitle: "单选题",
        option: "选项",
        trackName: "evaluation"
      },
      split_line: {
        template: "q-split-line",
        name: "分割线",
        trackName: "split_line"
      },
      countdown: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      countdown_show_only: {
        template: "q-count-down",
        name: "倒计时",
        trackName: "pc_q_count_down"
      },
      score_single: {
        template: "q-select",
        title: "请问你对以下描述的感觉是",
        name: "评分单选",
        trackName: "pc_q_grade_single"
      },
      work_age: {
        template: "q-select",
        title: "您的工作年限是？",
        name: "工龄",
        trackName: "pc_q_seniority"
      },
      base_info: {
        template: "q-multi-blank",
        title: "请填写您的基本信息",
        name: "基本信息",
        trackName: "pc_q_basic"
      },
      navigation: {
        template: "q-navigation",
        name: "地图导航",
        trackName: "navigation",
        title: "导航到这里"
      },
      page: {
        template: "q-page",
        name: "分页",
        trackName: "page"
      },
      multiple_dropdown: {
        template: "q-default",
        name: "下拉",
        title: "请选择以下选项 (多选)",
        option: "选项",
        trackName: "dropdown"
      },
      delivery_address: {
        template: "q-delivery-address",
        name: "收货信息",
        title: "请输入收货信息",
        trackName: "delivery_address"
      },
      ...expendsData
    };
    return {
      typeList: Object.keys(types),
      typesData: types,
      // 正向操作
      has() {
        for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
          keys[_key] = arguments[_key];
        }
        return keys.every(item => this.typeList.includes(item));
      },
      // 反向操作
      revHas(name) {
        let prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "name";
        let typeKey = "undefined";
        this.typeList.find(
        // eslint-disable-next-line no-return-assign
        key => {
          var _types$key;
          return (types === null || types === void 0 ? void 0 : (_types$key = types[key]) === null || _types$key === void 0 ? void 0 : _types$key[prop]) === name && (typeKey = key);
        });
        return typeKey;
      }
    };
  },
  //  新增接口参数
  appendLoginParams(params) {
    var _this$$route;
    const {
      page_id,
      invite_id,
      regfromsource,
      regfrommid
    } = (this === null || this === void 0 ? void 0 : (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : _this$$route.query) || {};
    const obj = {
      page_id,
      invite_id,
      regfromsource,
      regfrommid
    };
    Object.keys(obj).forEach(key => {
      if (obj[key] == 0 || !!obj[key]) params[key] = obj[key];
    });
  }
};
// if (typeof exports !== "undefined") {
//     export default $wj_tools;
// }
// if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
//     module.exports = $wj_tools;
// }

/* harmony default export */ __webpack_exports__["default"] = ($wj_tools);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(17)))

/***/ })

/******/ })["default"];